import { isCorsFriendly, isLikelyCorsBlocked } from '@/services/recipe-proxy'

export const isCorsBlockedBadge = (urlInput: string) => {
  try {
    new URL(urlInput)
    if (isCorsFriendly(urlInput)) {
      return <span className="text-green-500" title="Waarschijnlijk CORS-vriendelijk">OK</span>
    }
    if (isLikelyCorsBlocked(urlInput)) {
      return <span className="text-red-500" title="Waarschijnlijk CORS-geblokkeerd">X</span>
    }
    return <span className="text-yellow-500" title="Onbekend - proberen">?</span>
  } catch {
    return <span className="text-gray-400" title="Ongeldige URL">!</span>
  }
}
